import { render, staticRenderFns } from "./talent-matrix.vue?vue&type=template&id=10628258&scoped=true&"
import script from "./talent-matrix.vue?vue&type=script&lang=js&"
export * from "./talent-matrix.vue?vue&type=script&lang=js&"
import style0 from "./talent-matrix.vue?vue&type=style&index=0&id=10628258&scoped=true&lang=css&"
import style1 from "./talent-matrix.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10628258",
  null
  
)

export default component.exports